<template>
  <div>
    <!-- Custom Checkout Modal -->
    <div v-if="showCheckoutModal" class="custom-checkout-modal-overlay" @click.self="closeCheckoutModal">
      <div class="custom-checkout-modal-content">
        <button class="custom-checkout-modal-close" @click="closeCheckoutModal">
          <i class="fa-solid fa-xmark"></i>
        </button>
        <ModalStripeCheckout
          :numberRef="numberRef"
          :price="finalPrice"
          :code="discountApplied > 0 ? couponCode : ''"
          @close="closeCheckoutModal"
        />
      </div>
    </div>

    <!-- Coupon Alert Modal -->
    <modal
      name="coupon-msg-modal"
      :width="350"
      height="auto"
      :adaptive="true"
      classes="v--modal custom-coupon-modal"
    >
      <div style="padding: 24px; text-align: center;">
        <i v-if="!couponError" class="fa-solid fa-circle-check" style="font-size: 3rem; color: #16A34A; margin-bottom: 16px;"></i>
        <i v-if="couponError" class="fa-solid fa-circle-exclamation" style="font-size: 3rem; color: #DC2626; margin-bottom: 16px;"></i>
        <h3 style="font-size: 1.2rem; font-weight: 700; margin-bottom: 12px; color: #111827;">
          {{ couponError ? ($func.parseIso('error') || 'Error') : ($func.parseIso('success') || 'Success') }}
        </h3>
        <p style="font-size: 0.95rem; color: #4B5563; margin-bottom: 24px;">{{ couponMessage }}</p>
        <button class="pg-promo-btn" style="width: 100%; padding: 14px; display: block;" @click="$modal.hide('coupon-msg-modal')">
          {{ $func.parseIso('btnOk') || 'OK' }}
        </button>
      </div>
    </modal>

    <div class="payment-gui-wrapper">
      <h1 class="pg-page-title">{{ $func.parseIso('securePayment') || 'Secure Payment' }}</h1>

      <!-- Warning Banner -->
      <div class="pg-warning-banner mb-30">
        <i class="fa-solid fa-lock mr-10" style="color:#9A3412; font-size: 0.9em;"></i>
        <span>{{ $func.parseIso('msgConfirmPayment') || 'Please complete your payment. You have 30 minutes to complete the payment.' }}</span>
      </div>

      <!-- Payment Processor & Promo Code Row -->
      <div class="pg-row-cols mb-30">

        <!-- Stripe Card Column -->
        <div class="pg-col flex-1">
          <h3 class="pg-heading">{{ $func.parseIso('paymentProcessor') || 'PAYMENT PROCESSOR' }}</h3>
          <div class="pg-card stripe-card info-only">
            <div class="pg-cc-icon">
              <img src="@/assets/visa_card.png" alt="Visa" class="pg-cc-img-visa" />
              <img src="@/assets/master_card.png" alt="MasterCard" class="pg-cc-img-master" />
            </div>
            <div class="pg-stripe-divider"></div>
            <div class="pg-stripe-text">
              <i class="fa-solid fa-circle-check pg-check-icon"></i>
              <span style="margin-right: 6px;">{{ $func.parseIso('securelyProcessedBy') || 'Securely processed by' }}</span>
              <img src="@/assets/stripe_logo.png" alt="Stripe" class="pg-stripe-logo-img" />
            </div>
            <input type="radio" id="system_stripe" name="payment_system" checked style="display:none;" />
          </div>
        </div>

        <!-- Promo Code Column -->
        <div class="pg-col flex-1">
          <h3 class="pg-heading">{{ $func.parseIso('promotionCode') || 'PROMOTION CODE' }}</h3>
          <div class="pg-promo-wrapper">
            <input
              id="j_id_2jk:promoCode"
              name="j_id_2jk:promoCode"
              type="text"
              class="pg-promo-input"
              v-model="couponCode"
              :placeholder="$func.parseIso('enterDiscountCode') || 'Enter discount code'"
            />
            <button class="pg-promo-btn" type="button" @click="applyCoupon">
              {{ $func.parseIso('btnApply') || 'Apply' }}
            </button>
          </div>
        </div>

      </div>

      <!-- Order Breakdown -->
      <div class="pg-section mb-30">
        <div class="pg-breakdown-box">
          <div class="pg-bd-row">
            <span class="pg-bd-label">{{ $func.parseIso('reservation') || 'Reservation' }}</span>
            <span class="pg-bd-val">$ {{ originalPrice }}</span>
          </div>
          <div class="pg-bd-row" v-if="discountApplied > 0">
            <span class="pg-bd-label" style="color:#16A34A;">{{ $func.parseIso('discountAppliedText') || 'Discount applied' }} ({{ couponCode.toUpperCase() }})</span>
            <span class="pg-bd-val" style="color:#16A34A;">-$ {{ discountApplied }}</span>
          </div>

          <hr class="pg-bd-divider" />

          <div class="pg-bd-total-row">
            <span class="pg-bd-total-label">{{ $func.parseIso('totalAmount') || 'Total Amount' }}</span>
            <span class="pg-bd-total-val">$ {{ finalPrice }}</span>
          </div>
        </div>
      </div>

      <!-- Badges -->
      <div class="pg-badges mb-30">
        <div class="pg-badge">
          <i class="fa-solid fa-shield-alt"></i>
          <span>{{ $func.parseIso('encryptionBadge') || '256-BIT AES ENCRYPTION' }}</span>
        </div>
        <div class="pg-badge">
          <i class="fa-solid fa-unlock-alt"></i>
          <span>{{ $func.parseIso('privacyBadge') || 'PRIVACY GUARANTEED' }}</span>
        </div>
        <div class="pg-badge">
          <i class="fa-solid fa-bolt"></i>
          <span>{{ $func.parseIso('confirmationBadge') || 'INSTANT CONFIRMATION' }}</span>
        </div>
      </div>

      <!-- Buttons -->
      <div class="pg-buttons-footer mt-40">
        <a class="pg-btn-cancel" @click="goCancel">
          <i class="fa-solid fa-arrow-left mr-10" style="font-size: 0.85em;"></i> {{ $func.parseIso('cancelTransaction') || 'Cancel Transaction' }}
        </a>
        <a class="pg-btn-pay" @click="pay">
          <span>{{ $func.parseIso('pay') || 'Pay' }} $ {{ finalPrice }} USD</span>
          <i class="fa-solid fa-shield-alt ml-10"></i>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import ModalStripeCheckout from "./ModalStripeCheckout.vue";
export default {
  props: {
    week: { type: Object, default: () => ({}) },
    numberRef: { type: String, default: null },
    price: { type: [Number, String], default: null },
    iso: { type: String, default: "es" },
  },
  data() {
    return {
      couponCode: "",
      couponMessage: "",
      couponError: false,
      discountApplied: 0,
      showCheckoutModal: false,
    };
  },
  computed: {
    originalPrice() {
      return this.price;
    },
    finalPrice() {
      const base = parseFloat(this.price) || 0;
      const disc = parseFloat(this.discountApplied) || 0;
      return Math.max(0, base - disc);
    },
  },
  components: {
    ModalStripeCheckout,
  },
  async created() {
    this.$bus.on("change-iso", () => {
      this.$forceUpdate();
    });
  },
  methods: {
    goCancel() {
      this.$emit("cancel");
    },
    formatDate(date) {
      return this.$moment(date).format("LL");
    },
    async applyCoupon() {
      if (!this.couponCode) return;
      this.couponMessage = "";
      this.couponError = false;

      try {
        let email = "";
        try {
          const rawMember = localStorage.getItem("member");
          if (rawMember) {
            const parsedMember = JSON.parse(rawMember);
            email = parsedMember.Email || parsedMember.email || "";
          }
        } catch (e) {
          console.warn('Could not parse member email from localstorage');
        }

        const payload = {
          Codigo: this.couponCode,
          Email: email,
          Monto: this.originalPrice
        };
        const { data } = await this.$axios.post("/cupones/validate", payload);

        if (data.ok) {
          this.couponMessage = this.$func.parseIso('validCoupon') || data.message || "Cupón válido";
          this.discountApplied = data.Descuento || 0;
        } else {
          this.couponMessage = this.$func.parseIso('invalidCoupon') || "El cupón ya no es válido";
          this.couponError = true;
          this.discountApplied = 0;
        }
      } catch (error) {
        this.couponMessage = this.$func.parseIso('invalidCoupon') || "El cupón ya no es válido";
        this.couponError = true;
        this.discountApplied = 0;
      }

      this.$modal.show("coupon-msg-modal");
    },
    async pay() {
      console.log("Opening checkout modal");
      this.showCheckoutModal = true;
    },
    closeCheckoutModal() {
      this.showCheckoutModal = false;
      this.bCloseModal();
    },
    bCloseModal(){
      console.log('cerrando')
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

.payment-gui-wrapper {
  font-family: 'Inter', -apple-system, sans-serif;
  color: #111827;
}

/* Custom Modal Styles */
.custom-checkout-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(17, 24, 39, 0.75);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  backdrop-filter: blur(4px);
}

.custom-checkout-modal-content {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 1300px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.custom-checkout-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: #f3f4f6;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #4b5563;
  font-size: 1rem;
  transition: all 0.2s ease;
  z-index: 10;
}

.custom-checkout-modal-close:hover {
  background: #e5e7eb;
  color: #111827;
}
.pg-page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1F2937;
  margin-bottom: 24px;
}
.pg-warning-banner {
  background-color: #FFEDD5;
  color: #9A3412;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 16px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.pg-heading {
  font-size: 0.75rem;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
}

/* Grid layout */
.pg-row-cols {
  display: flex;
  gap: 20px;
  align-items: stretch;
}
.flex-1 {
  flex: 1;
}
.h-100 {
  height: 100%;
}

/* Cards */
.pg-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  border: 1px solid #F3F4F6;
  transition: all 0.2s ease;
}
.pg-card:not(.info-only) {
  cursor: pointer;
}
.pg-card.active-card {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

/* Summary icon */
.pg-summary-icon {
  width: 48px;
  height: 48px;
  background: #F3F4FB;
  color: #4338CA;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  margin-right: 20px;
}

/* Card Texts */
.pg-card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}
.pg-texts {
  display: flex;
  flex-direction: column;
}
.pg-main-text {
  font-weight: 600;
  color: #374151;
  font-size: 1.05rem;
}
.pg-sub-text {
  font-size: 0.85rem;
  color: #6B7280;
  margin-top: 4px;
}
.pg-price-text {
  font-weight: 800;
  color: #111827;
  font-size: 1.35rem;
}

/* Stripe Card */
.pg-card.stripe-card {
  padding: 0 20px;
  height: 68px;
}
.pg-cc-icon {
  margin-right: 18px;
  display: flex;
  align-items: center;
  position: relative;
  width: 84px;
  height: 52px;
}
.pg-cc-icon img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.pg-cc-img-visa {
  animation: pgFadeAlternator 6s infinite;
}
.pg-cc-img-master {
  animation: pgFadeAlternator 6s infinite 3s;
  opacity: 0;
}
@keyframes pgFadeAlternator {
  0%, 40% { opacity: 1; }
  50%, 90% { opacity: 0; }
  100% { opacity: 1; }
}
.pg-stripe-logo-img {
  height: 20px;
  width: auto;
  object-fit: contain;
}
.pg-stripe-divider {
  width: 1px;
  height: 24px;
  background: #E5E7EB;
  margin-right: 16px;
}
.pg-stripe-text {
  font-size: 0.95rem;
  color: #4B5563;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.pg-check-icon {
  color: #4B5563;
  margin-right: 8px;
  font-size: 1.1rem;
}

/* Promo Code */
.pg-promo-wrapper {
  display: flex;
  gap: 16px;
  height: 68px;
}
.pg-promo-input {
  flex: 1;
  background: #F8FAFC;
  border: 1px solid #F1F5F9;
  border-radius: 8px;
  padding: 0 20px;
  font-size: 1rem;
  color: #334155;
  transition: border-color 0.2s;
  outline: none;
}
.pg-promo-input:focus {
  border-color: #CBD5E1;
}
.pg-promo-btn {
  background: #0F172A;
  color: #FFFFFF;
  border: none;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0 48px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}
.pg-promo-btn:hover {
  background: #1E293B;
}

.pg-coupon-msg {
  margin-top: 10px;
  font-size: 0.85rem;
  font-weight: 500;
}
.pg-coupon-success {
  color: #16A34A;
}
.pg-coupon-error {
  color: #DC2626;
}

/* Order Breakdown */
.pg-breakdown-box {
  background: #F8FAFC;
  border-radius: 12px;
  padding: 24px 30px;
}
.pg-bd-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  font-size: 0.95rem;
}
.pg-bd-label {
  color: #4B5563;
  font-weight: 500;
}
.pg-bd-val {
  color: #374151;
  font-weight: 600;
}
.pg-bd-divider {
  border: none;
  border-top: 1px solid #E5E7EB;
  margin: 20px 0;
}
.pg-bd-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.pg-bd-total-label {
  color: #111827;
  font-weight: 700;
  font-size: 1.05rem;
}
.pg-bd-total-val {
  color: #4338CA;
  font-weight: 800;
  font-size: 1.5rem;
}
.pg-bd-notice {
  background: #EEF2FF;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 0.8rem;
  color: #6B7280;
  line-height: 1.4;
}

/* Buttons */
.pg-buttons-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pg-btn-cancel {
  font-weight: 600;
  color: #4B5563;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.pg-btn-pay {
  background: #22C55E;
  color: #FFFFFF;
  font-weight: 700;
  font-size: 1.1rem;
  padding: 16px 36px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);
  display: flex;
  align-items: center;
  transition: background 0.2s;
}
.pg-btn-pay:hover {
  background: #16A34A;
}

/* Badges */
.pg-badges {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding-bottom: 30px;
}
.pg-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #4338CA;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.05em;
}
.pg-badge i {
  font-size: 1.15rem;
  margin-bottom: 8px;
}

/* Modal Fixes */
:deep(.v--modal-overlay .v--modal.custom-coupon-modal) {
  border-radius: 12px !important;
  box-shadow: 0 15px 50px rgba(0,0,0,0.2) !important;
}

@media (max-width: 600px) {
  .pg-row-cols {
    flex-direction: column;
  }
  .pg-col .pg-heading[style*="opacity"] {
    display: none;
  }
  .pg-buttons-footer {
    flex-direction: column-reverse;
    gap: 20px;
  }
  .pg-btn-pay {
    width: 100%;
    justify-content: center;
  }
  .pg-badges {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .pg-card-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .pg-promo-wrapper {
    flex-direction: column;
  }
  .pg-promo-btn {
    padding: 16px;
  }
}
</style>
